module.exports = __webpack_public_path__ + "img/bg_decorat.99ff8277.png";